import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  configMessagesConfigurationRequest,
  configMessagesConfigurationSuccess,
  configMessagesConfigurationError
} from './actions';
import {
  ConfigActionsTypes,
  Message
} from './types';
import { callApi } from '../../utils/api';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || '';

function* handleConfigMessagesConfigurationRequest(action: ReturnType<typeof configMessagesConfigurationRequest>) {
  try {
    let res = yield call(callApi, 'get', API_ENDPOINT, `/configuration/messages`)

    var resJson: Message[] = res;
    let nextActions: any[] = [put(configMessagesConfigurationSuccess(resJson))]

    yield res.error ? put(configMessagesConfigurationError(res.error)) : all(nextActions);
  }
  catch (err) {
    yield err instanceof Error
      ? put(configMessagesConfigurationError(err.stack!))
      : put(configMessagesConfigurationError('An unknown error occured.'));
  }
}

function* watchConfigMessagesConfigurationRequest() {
  yield takeEvery(
    ConfigActionsTypes.CONFIG_MESSAGESCONFIGURATION_REQUEST,
    handleConfigMessagesConfigurationRequest
  );
}

function* configSaga() {
  yield all([fork(watchConfigMessagesConfigurationRequest)]);
}

export { configSaga as ConfigSaga }